import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Calendar } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import DateElementQuestion from 'modules/forms/components/QuestionComponent/DateElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

/**
 * DateElement class for date input elements.
 * Extends the base Element class.
 */
export class DateElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): DateElement {
    const el = new DateElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked, //locked element are always mandatory
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.date')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'date'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Calendar
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <DateElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <DateElementQuestion element={this} onChange={onChange} />
  }
}
